import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import { UserModel } from '../../models/user/userModel';
import { Link } from "react-router-dom";
import * as HelperFunctions from "../../common/functions/helperFunctions";
import UserService from '../../services/userService';
import Growl from '../../common/components/alertMessage/growl';
import GrowlContent from '../../common/components/alertMessage/growlContent';

interface IProps {
    history: any,
    location: any
}

interface IState {
    isLoading: boolean;
    mode: string;
}

class ConfirmContainerComponent extends React.Component<IProps, IState> {
    userService = new UserService();
    growl: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            mode: 'caretakerConfirm'
        };
    }

    componentDidMount() {
        let confirmCodeUrl = HelperFunctions.getURLParameter('confirmCaretakerCode');

        if (confirmCodeUrl) {
            let confirmCode = decodeURIComponent(confirmCodeUrl + '');
            this.validateConfirmCode(confirmCode);
        }
    }

    validateConfirmCode(confirmCode) {
        this.setState({
            isLoading: true
        });

        this.userService.validateCaretaker(confirmCode).then(
            (data: any) => {
                if (data) {
                    this.setState({
                        isLoading: false
                    })
                } else {
                    this.setState({
                        isLoading: false,
                        mode: 'notValidLink'
                    })
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    mode: 'notValidLink'
                });
            });
    }

    public render() {
        const { isLoading, mode } = this.state;

        const caretakerConfirm =
            <>
                <div>
                    <GrowlContent variant="success" message={Translate('You have successfully accept invitation')} />
                </div>
            </>
        const notValidLink =
            <>
                <div>
                    <GrowlContent variant="error" message={Translate('4005')} />
                </div>
            </>

        let resultHtml;

        switch (mode) {
            case 'caretakerConfirm':
                resultHtml = caretakerConfirm;
                break;
            case 'notValidLink':
                resultHtml = notValidLink;
                break;
            default:
                resultHtml = '';
        }

        return (
            <div className="app-content">

                {isLoading ? <Spinner /> : null}
                <Growl ref={(el) => this.growl = el} />

                <h1>{Translate('Confirm')}</h1>

                <div>
                    {resultHtml}
                </div>
            </div>
        )
    }
}

export default ConfirmContainerComponent;